import { render } from "./InvitePS.vue?vue&type=template&id=24fa37e6"
import script from "./InvitePS.vue?vue&type=script&lang=js"
export * from "./InvitePS.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__